class CdHamburger extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.trigger = this.querySelector('[data-cd-hamburger-trigger]');
    this.overlay = this.querySelector('[data-cd-hamburger-overlay]');
    this.panel = this.querySelector('[data-cd-hamburger-panel]');
    this.closeButton = this.querySelector('[data-cd-hamburger-close]');
    this.lastFocus = null;

    this.onTrigger = () => this.toggle();
    this.onClose = () => this.close();
    this.onKeydown = (event) => this.handleKeydown(event);
    this.onLinkClick = () => this.close();

    this.trigger?.addEventListener('click', this.onTrigger);
    this.overlay?.addEventListener('click', this.onClose);
    this.closeButton?.addEventListener('click', this.onClose);
    this.panel?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', this.onLinkClick);
    });
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onTrigger);
    this.overlay?.removeEventListener('click', this.onClose);
    this.closeButton?.removeEventListener('click', this.onClose);
    document.removeEventListener('keydown', this.onKeydown);
    this.unlockScroll();
  }

  get isOpen() {
    return this.classList.contains('is-open');
  }

  toggle() {
    if (this.isOpen) this.close();
    else this.open();
  }

  open() {
    if (this.isOpen) return;
    this.lastFocus = document.activeElement;
    this.trigger?.setAttribute('aria-expanded', 'true');
    this.overlay?.removeAttribute('hidden');
    this.panel?.removeAttribute('hidden');
    this.panel?.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => this.classList.add('is-open'));
    this.lockScroll();
    document.addEventListener('keydown', this.onKeydown);
    (this.closeButton || this.panel?.querySelector('a'))?.focus();
  }

  close() {
    if (!this.isOpen) return;
    this.classList.remove('is-open');
    this.trigger?.setAttribute('aria-expanded', 'false');
    this.panel?.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      if (this.isOpen) return;
      this.overlay?.setAttribute('hidden', '');
      this.panel?.setAttribute('hidden', '');
    }, 220);
    this.unlockScroll();
    document.removeEventListener('keydown', this.onKeydown);
    if (this.lastFocus instanceof HTMLElement) this.lastFocus.focus();
    else this.trigger?.focus();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab' || !this.panel) return;

    const focusable = [this.closeButton, ...this.panel.querySelectorAll('a')].filter(
      (node) => node instanceof HTMLElement
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  lockScroll() {
    document.documentElement.classList.add('cd-hamburger-open');
    document.body.classList.add('cd-hamburger-open');
  }

  unlockScroll() {
    document.documentElement.classList.remove('cd-hamburger-open');
    document.body.classList.remove('cd-hamburger-open');
  }
}

if (!customElements.get('cd-hamburger')) {
  customElements.define('cd-hamburger', CdHamburger);
}
